import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";
import { formatDateForMySQL } from "../../../components/formatDate";

export const SaveEmployee = async (employee) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
        let Payload  =[
            {                
              "isActive": employee.isActive,
              "employeeID": employee.employeeID,  
              "firstName": employee.firstName,
              "lastName": employee.lastName,
              "email": employee.email,
              "phoneNumbers": employee.phoneNumbers,
              "roleID": parseInt(employee.roleID) || null,
              "skillID": parseInt(employee.skillID) || null,
              "title": employee.title,
              "dateOfBirth": employee?.dateOfBirth !== '0001-01-01T00:00:00' && employee?.dateOfBirth ? formatDateForMySQL( new Date(employee.dateOfBirth)) : '0001-01-01T00:00:00',  
              "referredBy": employee.referredBy,
              "address": employee.address,
              "city": employee.city,
              "stateProvince": employee.stateProvince,
              "postalCode": employee.postalCode,
              "county": employee.county,
              "emergencyContactName": employee.emergencyContactName,
              "emergencyContactRelationship": employee.emergencyContactRelationship,
              "emergencyContactPhone": employee.emergencyContactPhone,
              "hireDate": employee?.hireDate !== '0001-01-01T00:00:00' && employee?.hireDate ? formatDateForMySQL( new Date(employee.hireDate)) : '0001-01-01T00:00:00',
              "employmentStatus": employee.employmentStatus,
              "departmentID": employee.departmentID, 
              "jobTitle": employee.jobTitle,
              "probationEndDate":  employee?.probationEndDate !== '0001-01-01T00:00:00' && employee?.probationEndDate ? formatDateForMySQL( new Date(employee.probationEndDate)) : '0001-01-01T00:00:00',
              "drivingLicenseValid": employee.drivingLicenseValid,
              "drivingLicenseExpiryDate": employee?.drivingLicenseExpiryDate !== '0001-01-01T00:00:00' && employee?.drivingLicenseExpiryDate ? formatDateForMySQL( new Date(employee.drivingLicenseExpiryDate)) : '0001-01-01T00:00:00', 
              "wageAmount": employee.wageAmount, 
              "wageType": employee.wageType,
              "clockInOutRequired": employee.clockInOutRequired,
              "userID" : employee.userID,
              "empType" : employee.empType,
              "weeklyHours" : employee.weeklyHours,
              "tags":employee.tags,
              "employeeHours":employee.employeeHours,
              "overtimeExempt":employee.overtimeExempt,
              "street2": employee.street2,
            }
          ];


          console.log(Payload);
      const response = await fetch(`${dev_baseUrl}/Employee/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      
      const data = await response.json();                      
        return data      
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
